import { useEffect, useRef } from "react";
import Store from "../../actions/store";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import produce from "immer";
import { Grid } from "@mui/material";
const initialFValues = {
  locationName: "",
  locationAddress: "",
  editing: false,
};
const AddStore = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  setStores,
  edite,
}) => {
  useEffect(() => {
    if (recordForEdit != null && edite) {
      setValues({
        ...recordForEdit,
      });
    }
  }, [recordForEdit]);
  const { addStore, updateStore } = Store();
  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    if ("locationAddress" in fieldValues)
      temp.locationAddress =
        fieldValues.locationAddress.length != 0
          ? ""
          : "This field is required.";
    if ("locationAddress" in fieldValues) {
      temp.locationAddress =
        fieldValues.locationAddress.length >= 2
          ? ""
          : "Location Address must be at least 2 characters.";
    }
    if ("locationName" in fieldValues)
      temp.locationName =
        fieldValues.locationName.length !== 0 ? "" : "This field is required.";
    if ("locationName" in fieldValues) {
      temp.locationName =
        fieldValues.locationName.length >= 2
          ? ""
          : "Location Name must be at least 2 characters.";
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);
  const firstFieldRef = useRef(null);
  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append(
      "image",
      values.image instanceof File ? values.image : null
    );
    if (validate()) {
      setValues({ ...values, submitting: true });
      if (edite === false) {
        delete values.logginError;
        delete values.editing;
        addStore(values).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else if (data.store) {
            NotifyMessage({
              message: "Store successfully created",
              type: "success",
            });
            setOpenPopup(false);
            setStores(
              produce((draft) => {
                draft.unshift({ ...data.store });
              })
            );
            resetForm();
          }
        });
      } else {
        delete values.logginError;
        delete values.editing;
        updateStore(values, values.id).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else {
            NotifyMessage({
              message: "Store successfully updated",
              type: "success",
            });
            setOpenPopup(false);
            resetForm();
            setStores(
              produce((draft) => {
                const index = draft.findIndex(
                  (store) => store.id === recordForEdit.id
                );

                if (index !== -1) draft[index] = data.store;
              })
            );
          }
        });
      }
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="locationName"
            label="Location Name"
            value={values.locationName}
            onChange={handleInputChange}
            error={errors.locationName}
            inputRef={firstFieldRef}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="locationAddress"
            label="Location Address"
            value={values.locationAddress}
            onChange={handleInputChange}
            error={errors.locationAddress}
          />
        </Grid>
        <Grid item xs={12}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={
                edite === true
                  ? values.submitting
                    ? "Editing..."
                    : "Done"
                  : values.submitting
                  ? "Adding..."
                  : "Add"
              }
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              color="default"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddStore;
